import React, { useState } from 'react';
import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Text,
} from '@chakra-ui/react';

import { useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  return (
    <>
      <Text fontSize="34px" color="#1b254b" fontWeight="700">
        {location.pathname === '/testMeMode' ? 'Test Me Mode' : 'SMART Notes'}
      </Text>
      <Flex direction="column" justifyContent="center" alignItems="center">
        <Text
          fontSize={{ base: '1.2rem', md: '2rem' }}
          color="#1b254b"
          fontWeight="800"
        >
          {location.pathname === '/testMeMode' ? (
            <>
              Create Your Own
              <span style={{ color: '#4318FF' }}> Quizzes</span>
            </>
          ) : (
            <>
              Create Your
              <span style={{ color: '#4318FF' }}> Knowledge Base</span>
            </>
          )}
        </Text>
        <Text
          display={{ base: 'none', sm: 'block' }}
          align="center"
          fontSize="0.9rem"
          color="#718096"
          fontWeight="500"
        >
          {location.pathname === '/testMeMode'
            ? 'Upload study materials, and generate custom quizzes'
            : 'Upload all study materials, and Studywise will turn them into SMART Notes'}
        </Text>
      </Flex>
    </>
  );
};

export default Header;
